'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EffectRegistry = undefined;

exports.default = function (name, callback) {
  if (typeof name !== 'string') {
    throw new Error('Named effects require a valid string as the name eg. Effect("myAction", () => {...})');
  }

  if (_actions2.default[name]) {
    throw new Error('An action called "' + name + '" already exists! Please pick another name for this effect!');
  }

  var callbackWrapper = function callbackWrapper(action) {
    var payload = action.payload,
        ts = action.ts;

    Promise.resolve(callback(payload, _middleware.getState, _middleware.dispatch)).then(effectPromises[ts].resolve).catch(effectPromises[ts].reject);
  };

  EffectRegistry[name] = callbackWrapper;

  var eventDispatcher = function eventDispatcher(payload) {
    var ts = Date.now();
    return new Promise(function (resolve, reject) {
      effectPromises[ts] = { resolve: resolve, reject: reject };
      (0, _middleware.dispatch)({
        type: name,
        payload: payload,
        ts: ts
      });
    });
  };

  (0, _actions.addAction)(name, eventDispatcher);

  eventDispatcher.cancel = function () {
    delete EffectRegistry[name];
    (0, _actions.removeAction)(name);
  };

  return eventDispatcher;
};

var _middleware = require('./middleware');

var _actions = require('./actions');

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EffectRegistry = exports.EffectRegistry = {};
var effectPromises = {};


//////////////////
// WEBPACK FOOTER
// ./~/jumpstate/lib/effect.js
// module id = 328
// module chunks = 0